import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import { FC } from "react";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import type { MaterialCategory } from "../../../../http/envelopeDesigner/types/materialCategory";
import { useMaterialClassificationApi } from "../../../../http/envelopeDesigner/useAdminEnvelopeDesigner";
import MaterialCategoryFormDialog from "./MaterialCategoryFormDialog";

// The categories of the material library: a hidden one hides its materials (user side, except the ones a calculation
// uses); delete refused by the server while a material or a subcategory is of it.
const MaterialCategoriesTab: FC = () => {
  const i18n = useI18n();
  const t = i18n.translation.envelopeDesignerModule.admin;
  const { categories } = useMaterialClassificationApi();

  return (
    <AdminCrudTable<MaterialCategory>
      filterPrefix="material_categories"
      useList={categories.useSearch}
      head={
        <>
          <TableHeadCell align="left">{i18n.translation.common.code}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.name}</TableHeadCell>
          <TableHeadCell align="left">{t.condCategory}</TableHeadCell>
        </>
      }
      renderRow={(item) => (
        <>
          <TableCell>{item.code}</TableCell>
          <TableCell>{item.name}</TableCell>
          <TableCell>{item.condCategory}</TableCell>
        </>
      )}
      visibilityAndOrder={{
        updateVisibility: (item, visibility) => categories.updateVisibility(item.code, { visibility }),
        updateOrder: (item, order) => categories.updateOrder(item.code, { order }),
      }}
      onDelete={(item) => categories.remove(item.code)}
      deleteTitle={t.category}
      canAdd
      renderForm={(item, onClose) => <MaterialCategoryFormDialog category={item} onClose={onClose} />}
    />
  );
};

export default MaterialCategoriesTab;
